import React from 'react';
import { TFunction } from 'i18next';

import ContentWrapperInteractionStatus from '../../../blocks/ContentWrapper/partials/ContentWrapperInteractionStatus/ContentWrapperInteractionStatus';
import { Namespace } from '../../../../translation/namespace';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type ContentWrapperContainer = {
  uuid: string;
  elementType: string;
  contentWrapperContext?: ContentWrapperContext | null;
  t: TFunction;
};
export function ContentWrapperContainer({ uuid, elementType, contentWrapperContext, t }: ContentWrapperContainer) {
  if (uuid === contentWrapperContext?.error?.uuid) {
    return (
      <div className="content-wrapper__container">
        <ContentWrapperInteractionStatus
          message={
            contentWrapperContext?.error?.type !== 'addBlock'
              ? t(`${Namespace.ContentWrapper}:errors.${contentWrapperContext?.error?.type}.${elementType}`)
              : t(`${Namespace.ContentWrapper}:errors.${contentWrapperContext?.error?.type}`)
          }
        />
      </div>
    );
  }
  return null;
}
